import React, { PureComponent } from "react";

import { TTP_API_URL } from "Config";
//import SocialContainer from "../Social/SocialContainer";

import styles from "./Media.local.scss";
import { addLandaSize } from "Utils";

export default class MediaComponent extends PureComponent {
  render() {
    const { language, media } = this.props;
    const { preview, fullMediaUrl, webPath, docType } = media;

    const titleAttr = `title${language.charAt(0).toUpperCase() +
      language.slice(1)}`;

    let path = null;
    if (
      docType === "VIDEO" &&
      preview &&
      (preview.fullMediaUrl || preview.webPath)
    ) {
      path = preview.fullMediaUrl
        ? preview.fullMediaUrl
        : TTP_API_URL + "/" + preview.webPath;
    } else if (docType === "IMAGE") {
      path = fullMediaUrl ? fullMediaUrl : TTP_API_URL + "/" + webPath;
    }
    path = path ? addLandaSize(path, 120) : "/img/no-image.png";

    return (
      <div className={styles.media}>
        {docType === "PPT" || docType === "PDF" ? (
          <div className={styles.docs}>
            <img src={`/img/${docType.toLowerCase()}.png`} alt="" />
            <h4>{media[titleAttr]}</h4>
          </div>
        ) : (
          <div
            className={styles.mediaContent}
            style={{ backgroundImage: `url(${path})` }}
          >
            {docType === "VIDEO" ? (
              <img className={styles.play} src="/img/play.png" alt="" />
            ) : null}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Album/Media/MediaComponent.js